/* v8 ignore start */
import React from 'react';
import PropTypes from 'prop-types';

import BaseWizard from 'containers/BaseWizard';

import ExamplePage from './ExamplePage';

const PATH = 'Path Three';

const WizardPathThree = ({ wizardStore, handleClose }) => {
  return (
    <BaseWizard
      wizardStore={wizardStore}
      onClose={handleClose}
    >
      <ExamplePage
        pageHeader={`${PATH} Page One Header (No Sidebar and no Footer)`}
      />
    </BaseWizard>
  );
};

WizardPathThree.propTypes = {
  wizardStore: PropTypes.object,
  handleClose: PropTypes.func
};

export default WizardPathThree;
